type IconProps = React.SVGProps<SVGSVGElement>;

const Clock: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.75 4.75C10.75 4.33579 10.4142 4 10 4C9.58579 4 9.25 4.33579 9.25 4.75H10.75ZM10 10H9.25C9.25 10.4142 9.58579 10.75 10 10.75V10ZM15.25 10.75C15.6642 10.75 16 10.4142 16 10C16 9.58579 15.6642 9.25 15.25 9.25V10.75ZM19 10H18.25C18.25 14.5563 14.5563 18.25 10 18.25V19V19.75C15.3848 19.75 19.75 15.3848 19.75 10H19ZM10 19V18.25C5.44365 18.25 1.75 14.5563 1.75 10H1H0.25C0.25 15.3848 4.61522 19.75 10 19.75V19ZM1 10H1.75C1.75 5.44365 5.44365 1.75 10 1.75V1V0.25C4.61522 0.25 0.25 4.61522 0.25 10H1ZM10 1V1.75C14.5563 1.75 18.25 5.44365 18.25 10H19H19.75C19.75 4.61522 15.3848 0.25 10 0.25V1ZM10 4.75H9.25V10H10H10.75V4.75H10ZM10 10V10.75H15.25V10V9.25H10V10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Clock;
